import {Component, OnInit, ViewEncapsulation, Input, AfterViewInit, ViewChildren, QueryList} from '@angular/core';
import {BusinessRulesService} from "../../../core/business-rules/business-rules.service";
import {GameScheduleInfoModel} from "../../../core/business-rules/game-schedule-info.model";
import {MessageService} from "primeng/components/common/messageservice";
import {DrawDefTimeLimitComponent} from "../drawdef-time-limit/drawDef-time-limit.component";

@Component({
  selector: 'drawgroup-time-limit',
  templateUrl: 'drawGroup-time-limit.component.html',
  styleUrls: ['drawGroup-time-limit.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class DrawGroupTimeLimitComponent implements OnInit, AfterViewInit {

  info;
  drawDefinitions;
  infoLoaded: boolean = false;

  @Input() readOnly: boolean = false;
  @Input() gameName: string;

  @Input()
  set gameInfo(value) {
    this.info = value;
     setTimeout(() => {
      this.setValues();
    });
  }

  @Input()
  set drawDefs(value) {
    this.drawDefinitions = value;
    setTimeout(() => {
      this.setValues();
    });
  }

  @ViewChildren('drawItem') draws: QueryList<DrawDefTimeLimitComponent>;

  constructor(private businessService: BusinessRulesService,
              private messageService: MessageService) {

  }

  private setValues() {

    if (this.info || this.drawDefinitions) {
      this.infoLoaded = true;
    }

  }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  validDefinitions(): boolean {

    let valid = true;
    this.draws.forEach(item => {
      valid = valid && item.formGroup.valid;
    });
    return valid;

  }

  getChanges(): GameScheduleInfoModel[] {

    return this.draws
      .filter(item => item.formGroup.dirty)
      .map(item => item.buildModel());

  }

  resetChildren() {
    this.draws.forEach(item => item.formGroup.markAsPristine());
  }

  updateDrawDefinitions() {

    if (!this.validDefinitions()) {
      this.messageService.add({
        severity: 'warn',
        summary: '',
        detail: 'Existen errores en la captura.'
      });
      return;
    }

    let changes = this.getChanges();
    if (changes.length == 0) {
      this.messageService.add({
        severity: 'info',
        summary: '',
        detail: 'No se han detectado cambios.'
      });
      return;
    }

    this.businessService.setDrawDefinitionForGame(this.gameName.toLowerCase(), changes)
      .subscribe(response => {

        this.resetChildren();
        this.messageService.add({
          severity: 'success',
          summary: '',
          detail: 'La actualización fue satisfactoria.'
        });

      }, error => {
        console.error(error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error
        });
      });

  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/businessRules/drawGroup-time-limit/drawGroup-time-limit.component.ts